import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@moe/oss/ui/form";
import { Input } from "@moe/oss/ui/input";
import { Textarea } from "@moe/oss/ui/textarea";
import { TagBox } from "@web/components/tag/TagBox";
import { TagButton } from "@web/components/tag/TagButton";
import { TagInput } from "@web/components/tag/TagInput";
import { TagList } from "@web/components/tag/TagList";
import { TokenCounter } from "@web/components/TokenCounter";
import { BaseData } from "@web/route-services/studio/schema";
import { useFormContext } from "react-hook-form";

export function DetailsFields() {
  const form = useFormContext<BaseData>();

  return (
    <>
      <FormField
        control={form.control}
        name="title"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-tx-secondary text-base font-semibold md:text-lg">Title</FormLabel>
            <FormControl>
              <Input className="text-base font-medium" placeholder="Add a title to display on the card" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="tagline"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-tx-secondary text-base font-semibold md:text-lg">Tagline</FormLabel>
            <FormControl>
              <TagBox value={field.value || ""} onChange={field.onChange}>
                <TagInput
                  className="rounded-b-none"
                  multiline
                  rows={5}
                  placeholder="Add a short description of your character, creator notes, any thing you want here. This does not affect character responses. You may also add hash tags by using #."
                />
                <TagButton />
                <TagList className="border-none" />
              </TagBox>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-tx-secondary flex w-full items-center justify-between">
              <span className="text-base font-semibold md:text-lg">Name</span>
              <TokenCounter content={field.value} />
            </FormLabel>
            <FormControl>
              <Input className="text-base font-medium" placeholder="Add a name for your character" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="description"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-tx-secondary flex w-full items-center justify-between">
              <span className="text-base font-semibold md:text-lg">Description</span>
              <TokenCounter content={field.value} />
            </FormLabel>
            <FormControl>
              <Textarea
                className="text-base font-medium"
                placeholder="Add a description of your character"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* <FormField
        control={form.control}
        name="scenario"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-tx-secondary flex w-full items-center justify-between">
              <span className="text-base font-semibold md:text-lg">Scenario</span>
              <TokenCounter content={field.value} />
            </FormLabel>
            <FormControl>
              <Textarea
                className="text-base font-medium"
                placeholder="The current situation your character is in. Specifying scenario here instead of in the description field helps your character respond better in group chats."
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      /> */}

      <FormField
        control={form.control}
        name="greeting"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-tx-secondary flex w-full items-center justify-between">
              <span className="text-base font-semibold md:text-lg">Greeting</span>

              <TokenCounter content={field.value} />
            </FormLabel>
            <FormControl>
              <Textarea
                className="text-base font-medium"
                placeholder="The first message your character will say"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}
